// The cancel and change-dates pills now carry the agentic workflow keys; the legacy keys stay
// listed so chats rendered from history are filtered the same way.
const pastBookingActions = ['resendConfirmationEmail', 'cancelOrder', 'startAgenticCancellationWorkflow', 'changeRoom', 'changeDates', 'startAgenticChangeDatesWorkflow', 'requestRefundAction', 'requestDateChangeAction', 'shareBookingAction', 'specialRequestAction', 'changeGuestNameAction']

export const filterActions = (action: any, isPastBooking: boolean, skipActions: Array<string> = []) => {
  const actionsToSkip = isPastBooking ? [...pastBookingActions, ...skipActions] : skipActions
  return isChip(action) && !actionsToSkip.includes(action?.action?.key)
}

export const isChip = (action: App.ChatMessageMetaContent) => (action?.type === 'button' || action?.type === 'link')
export const isComponent = (action: App.ChatMessageMetaContent) => !isChip(action)
